var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('NumberFormGroup',{attrs:{"value":_vm.value.limit,"name":"limit","label":"Limit","error":(_vm.errors.limit || [])[0],"help-text":"The number of items to display."},on:{"input":function($event){return _vm.emit('limit', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }